(function ($) {
    var currentEventPage     = 1;
    var currentMode          = $('.nav-tabs-event').find('.active').data('mode');
    var calendarEvents       = [];
    var eventAjax            = null;
    var ajaxTimeout          = null;
    var bookingValidatedData = {
        validated: false,
        early_bird_tickets: [],
    };

    var loadEvent = function () {
        var templateGrid     = $('#js-event-grid-item').html();
        var templateCalendar = $('#js-event-calendar-item').html();
        var $loader          = $('.js-event-loader');
        var $list            = $('.js-event-list');
        var $loadMore        = $('.js-event-next-page');

        Mustache.parse(templateGrid);
        Mustache.parse(templateCalendar);

        var data = {
            page: currentEventPage,
            mode: currentMode,
            nonce: rissb_var.nonces.get_events,
        };

        if (window.matchMedia('(max-width: 768px)').matches) {
            data.filters = $('.filter-mobile .js-event-filters :input').serialize();
        } else {
            data.filters = $('.filter-desktop .js-event-filters :input').serialize();
        }

        if (data.page == 1) {
            $loader.removeClass('d-none');
            $list.empty();

            if (data.mode === 'calendar') {
                calendarEvents = [];
                $('#event-calendar').fullCalendar('refetchEvents');
            }
        }

        if (eventAjax) {
            eventAjax.abort();
        }

        eventAjax = $.post('/api/events', data, function (res) {
            var template   = data.mode === 'calendar' ? templateCalendar : templateGrid;
            var rendered   = Mustache.render(template, res.data);
            calendarEvents = res.data.data;

            $loader.addClass('d-none')

            if (data.page == 1) {
                $list.html(rendered);
            } else {
                $list.append(rendered);
            }

            if (data.mode === 'calendar' && $('#event-calendar').children().length) {
                $('#event-calendar').fullCalendar('refetchEvents');
                $('#event-calendar').fullCalendar('gotoDate', new Date(res.data.date.year, res.data.date.month_num - 1));
            }

            $(rendered).imagesLoaded(function() {
                $.fn.matchHeight._apply('[data-mh="event-thumb"]');
                $.fn.matchHeight._apply('[data-mh="event-content"]');
            });

            $loadMore.closest('div').toggleClass('d-none', res.data.pagination.total <= res.data.pagination.current);
        }).always(function () {
            $loadMore.text($loadMore.data('text-original'));
        });
    };

    var toggleFormGroupInvoicing = function () {
        var invoice = $('[name="single_booking_invoicing_option"], [name="group_booking_invoicing_option"]').filter(':checked').val();

        if (!invoice) {
            return;
        }

        $('.form-group-invoicing-group, .form-group-invoicing-me, .form-group-invoicing-company, .form-group-invoicing-per-attendee, .form-group-invoicing-enroller').addClass('d-none');
        $('.form-group-invoicing-' + invoice).removeClass('d-none');

        if (invoice === 'per-attendee' && $('[name="enroller_is_attendee"]').is(':checked')) {
            $('.form-group-invoicing-enroller').removeClass('d-none');
        }
    };

    $(document).ready(function () {
        if ($('body').hasClass('post-type-archive-event')) {

            // If no categories filter is selected,
            // by default will load all available entries.
            // However, client have requested to exclude "training" categories from this page.
            // Thus, need to exclude entries from "training" categories if the page is loading all entries. 
            // Or, check all the categories filters checkbox on page load (already hide "training" in template file).
            $('.js-dropdown-filter-category').find('[type="checkbox"][name="event_categories[]"]').prop('checked', true);

            RISSB.fn.clearDropdownFilter(function () {
                currentEventPage = 1;
                loadEvent();
            });

            var $calendar = $('#event-calendar');

            $calendar.fullCalendar({
                buttonIcons: false,
                contentHeight: 'auto',
                header: {
                    left:   'prev',
                    center: 'title',
                    right:  'next',
                },
                viewRender: function () {
                    var date = $('#event-calendar').fullCalendar('getDate');

                    if (currentMode === 'calendar') {
                        $('[name="event_months[]"]').prop('checked', false);
                        $('[name="event_years[]"]').prop('checked', false);
                        $('[name="event_months[]"][value="' + date.format('M') +'"]').prop('checked', true);
                        $('[name="event_years[]"][value="' + date.format('YYYY') +'"]').prop('checked', true);

                        $('[name="event_years[]"]').change();
                        loadEvent();
                    }

                    $('.fc-next-button').text(date.add(1, 'months').format('MMMM') + ' >');
                    $('.fc-prev-button').text('< ' + date.subtract(2, 'months').format('MMMM'));
                },
                eventLimit: 3,
                eventLimitClick: function () {
                    // do nothing for now
                },
                events: function (start, end, timezone, callback) {
                    callback(calendarEvents);
                },
                eventAfterAllRender: function () {
                    if (calendarEvents.length) {
                        $.each(calendarEvents, function (index, event) {
                            $('.fc-day-grid-event[href="' + event.url + '"]').css('background-color', event.category.color);
                        });
                    }
                }
            });

            $calendar.fullCalendar('gotoDate', new Date($calendar.data('year'), parseInt($calendar.data('month'), 10) - 1));

            if ($('.js-event-list').length) {
                currentEventPage = 1;
                loadEvent();
            }

            $('.js-event-filters').find('.js-event-search').on('keyup input', function () {
                currentEventPage = 1;

                clearTimeout(ajaxTimeout);
                ajaxTimeout = setTimeout(loadEvent, 500);
            });

            $('.js-update-filter').on('click', function () {
                var $this = $(this);
                var $checkboxes  = $this.closest('.dropdown-menu').find('input[type="checkbox"]');
                currentEventPage = 1;

                var names = $checkboxes.map(function () {
                    return $(this).attr('name');
                }).sort();

                $.each($.unique(names), function (index, name) {
                    RISSB.fn.updateQSParams(name, $this.closest('.dropdown-menu').find('input[name="' + name + '"]:checked').map(function () {
                        return $(this).val();
                    }).get(), true);
                });

                $(this).closest('.dropdown-menu').removeClass('show');
                loadEvent();
            });

            $('.js-event-next-page').on('click', function (e) {
                e.preventDefault();

                var $this = $(this);
                currentEventPage = currentEventPage + 1;

                $this.html('<i class="fas fa-spinner fa-spin fa-fw"></i> ' + $this.data('text-progress'));
                loadEvent();
            });

            $('.js-event-list').on('click', '.js-filter-category', function (e) {
                e.preventDefault();

                var $this = $(this);
                currentEventPage = 1;

                $('.js-dropdown-filter-category').find('[type="checkbox"][name="event_categories[]"]').prop('checked', false);
                $('.js-dropdown-filter-category').find('[type="checkbox"][name="event_categories[]"][value="' + $this.data('id') + '"]').prop('checked', true).change();
                $('.js-dropdown-filter-category').find('.js-update-filter').click();

                RISSB.fn.updateQSParams('event_categories[]', $this.data('id'));
                loadEvent();
            });

            $('.js-event-list').on('click', '.js-filter-topic', function (e) {
                e.preventDefault();

                var $this = $(this);
                currentEventPage = 1;

                $('.js-dropdown-filter-topic').find('[type="checkbox"][name="event_topics[]"]').prop('checked', false);
                $('.js-dropdown-filter-topic').find('[type="checkbox"][name="event_topics[]"][value="' + $this.data('id') + '"]').prop('checked', true).change();
                $('.js-dropdown-filter-topic').find('.js-update-filter').click();

                RISSB.fn.updateQSParams('event_topics[]', $this.data('id'));
                loadEvent();
            });

            $('.nav-tabs-event').find('[data-toggle="tab"]').on('show.bs.tab', function (e) {
                currentEventPage = 1;
                currentMode      = $(e.currentTarget).data('mode');

                RISSB.fn.updateQSParams('type', currentMode);
                loadEvent();
            });
        }

        if ($('body').hasClass('single-event')) {
            $('.is-sticky').stick_in_parent({
                offset_top: $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0,
            });

            $('.is-sticky-widget').stick_in_parent({
                parent: '#main',
                offset_top: $('.is-sticky').outerHeight() + 50
            });
        }

        // booking form
        if ($('body').hasClass('page-template-template-event-booking')) {
            $('[name="single_booking_invoicing_option"], [name="group_booking_invoicing_option"]').off('change').on('change', toggleFormGroupInvoicing).change();

            $('.js-same-email-address input[type="checkbox"]').on('change', function () {
                var $this = $(this);

                if ($this.is(':checked')) {
                    if ($this.closest('.js-accordion-attendee').length) {
                        $this.closest('.form-group').find('input[type="email"]').val($this.closest('.js-accordion-attendee').find('.js-form-group-email [type="email"]').val());
                    } else {
                        $this.closest('.form-group').find('input[type="email"]').val($('[name="email"]').val());
                    }
                }
            });

            $('[name="enroller_is_attendee"]').on('change', function () {
                $('.fieldset-enroller').toggleClass('d-none', !$(this).is(':checked'));
                toggleFormGroupInvoicing();
            }).change();

            $('.js-add-attendee').on('click', function (e) {
                e.preventDefault();

                var limit = 5;

                if ($('[name="enroller_is_attendee"]').is(':checked')) {
                    limit = 4;
                }

                if ($('.js-accordion-attendee').not('.d-none').length >= limit) {
                    alert('We are sorry, the current system will limit a Group booking to 5 attendees only. If you need to book more tickets, please start another Group booking form after you submit the current one.');
                    return;
                }

                // populate previous accordion attendee fullname
                var $prevAccordion = $('.js-accordion-attendee').not('.d-none').last();
                var fullname       = $.trim($prevAccordion.find('.js-form-group-first-name input').val()) + ' ' + $.trim($prevAccordion.find('.js-form-group-last-name input').val());

                $prevAccordion.find('[data-bind="fullname"]').text(fullname + ' - ');

                var $accordion = $('.js-accordion-attendee.d-none').eq(0);

                $accordion.find('.js-is-removed').val(0);
                $accordion.removeClass('d-none');
            });

            $('.js-remove-attendee').on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var $accordion = $(this).closest('.js-accordion-attendee');

                if (window.confirm('Are you sure you want to do this? This process is irreversible.')) {
                    RISSB.fn.clearFields($accordion);
                    $accordion.find('.js-is-removed').val(1);
                    $accordion.addClass('d-none');
                }
            });

            if ($('#form-create-booking').length) {
                $('#modal-booking-confirmation').on('show.bs.modal', function () {
                    var $modal = $(this);

                    $modal.find('[data-bind]').each(function () {
                        var $field = $(this);
                        var $input = $('[name="' + $field.data('bind') + '"]');

                        if ($.trim($field.data('id')) !== '') {
                            $input = $('[name="attendee[' + $field.data('id') +'][' + $field.data('bind') + ']"]');
                        }

                        $field.closest('tr').removeClass('d-none');

                        switch ($field.data('bind')) {
                            case 'dinner_attendance':
                                $field.text($input.filter(':checked').closest('.rissb-custom-control').find('span').text());

                                if ($.inArray('dinner_attendance', rissb_var.event.booking_fields) === -1) {
                                    $field.closest('tr').addClass('d-none');
                                }
                                break;

                            case 'dietary_requirements':
                            case 'accessibility_requirements':
                            case 'multipurpose_field_1':
                            case 'multipurpose_field_2':
                            case 'multipurpose_field_3':
                                $field.text($input.val());

                                if ($.inArray($field.data('bind'), rissb_var.event.booking_fields) === -1) {
                                    $field.closest('tr').addClass('d-none');
                                }
                                break;

                            case 'single_booking_invoicing_option':
                            case 'group_booking_invoicing_option':
                                $field.text($input.filter(':checked').closest('.rissb-custom-control').find('span').text());
                                break;

                            case 'billing_name':
                            case 'billing_address':
                                $field.text($input.val());

                                if ($('[name="single_booking_invoicing_option"]').filter(':checked').val() == 'company') {
                                    $field.closest('tr').addClass('d-none');
                                }
                                break;

                            case 'billing_email_address':
                                $field.text($input.val());

                                if ($('[name="group_booking_invoicing_option"]').filter(':checked').val() == 'per-attendee' && $.trim($field.data('id')) === '') {
                                    $field.closest('tr').addClass('d-none');
                                }

                                if ($('[name="group_booking_invoicing_option"]').filter(':checked').val() == 'per-attendee' && $('[name="enroller_is_attendee"]').is(':checked')) {
                                    $field.closest('tr').removeClass('d-none');
                                }
                                break;

                            case 'purchase_order_number':
                            case 'company_name':
                            case 'company_abn':
                            case 'company_postal_address':
                                $field.text($input.val());

                                if (
                                    $.trim($field.data('id')) === '' &&
                                    (
                                        $('[name="single_booking_invoicing_option"]').filter(':checked').val() == 'me' ||
                                        $('[name="group_booking_invoicing_option"]').filter(':checked').val() == 'per-attendee'
                                    )
                                ) {
                                    $field.closest('tr').addClass('d-none');
                                }

                                if ($('[name="group_booking_invoicing_option"]').filter(':checked').val() == 'per-attendee' && $('[name="enroller_is_attendee"]').is(':checked')) {
                                    $field.closest('tr').removeClass('d-none');
                                }
                                break;

                            case 'enroller_is_attendee':
                                $field.text($input.is(':checked') ? 'Yes' : 'No');
                                break;

                            case 'is_removed':
                                $field.toggleClass('d-none', $input.val() == 1);
                                break;

                            case 'fullname':
                                var fullname = $.trim($('[name="attendee[' + $field.data('id') +'][first_name]"]').val() + ' ' + $('[name="attendee[' + $field.data('id') +'][last_name]"]').val());

                                $field.text(fullname ? fullname + ' - ' : '');
                                break;

                            case 'billing_details':
                                $field.toggleClass('d-none', $('[name="group_booking_invoicing_option"]').filter(':checked').val() == 'group');
                                break;

                            case 'grand_total':
                                break;

                            default:
                                $field.text($input.val());
                                break;
                        }
                    });

                    $('.fieldset-attendee').toggleClass('d-none', !$('.js-accordion-attendee').not('.d-none').length);

                    var tickets = $('[name="tickets[]"]').filter(':checked').map(function () {
                        return $(this).val();
                    }).get();

                    $('.js-table-tickets').find('tr').addClass('d-none');
                    $('.js-table-tickets').find('[data-price]').addClass('d-none');

                    $('.js-table-tickets').each(function () {
                        var $table = $(this);

                        $.each(tickets, function (index, ticket) {
                            $table.find('tr[data-id="' + ticket + '"]').removeClass('d-none');
                            $table.find('tr[data-id="' + ticket + '"]').find('.td-price-early-bird').toggleClass('d-none', $.inArray(ticket, bookingValidatedData.early_bird_tickets) === -1);
                            $table.find('tr[data-id="' + ticket + '"]').find('.td-price').toggleClass('d-none', $.inArray(ticket, bookingValidatedData.early_bird_tickets) !== -1);
                        });
                    });

                    for (var i = 2; i <= 6; i++) {
                        var tickets = $('[name="attendee[' + i + '][tickets][]"]').filter(':checked').map(function () {
                            return $(this).val();
                        }).get();

                        $('.js-table-tickets-attendee-' + i).find('tr').addClass('d-none');
                        $('.js-table-tickets-attendee-' + i).find('[data-price]').addClass('d-none');

                        $.each(tickets, function (index, ticket) {
                            $('.js-table-tickets-attendee-' + i).find('tr[data-id="' + ticket + '"]').removeClass('d-none');
                            $('.js-table-tickets-attendee-' + i).find('tr[data-id="' + ticket + '"]').find('.td-price-early-bird').toggleClass('d-none', $.inArray(ticket, bookingValidatedData.early_bird_tickets) === -1);
                            $('.js-table-tickets-attendee-' + i).find('tr[data-id="' + ticket + '"]').find('.td-price').toggleClass('d-none', $.inArray(ticket, bookingValidatedData.early_bird_tickets) !== -1);
                        });
                    }

                    $modal.find('.js-table-striped-blue').each(function () {
                        $(this).find('tr').not('.d-none').each(function (index) {
                            var $this = $(this);

                            $this.removeClass('bg-secondary-light bg-secondary-lighter');

                            if (index % 2 === 0) {
                                $this.addClass('bg-secondary-light');
                            } else {
                                $this.addClass('bg-secondary-lighter');
                            }
                        });
                    });

                    $modal.find('.js-table-striped-green').each(function () {
                        $(this).find('tr').not('.d-none').each(function (index) {
                            var $this = $(this);

                            $this.removeClass('bg-green bg-green-lighter');

                            if (index % 2 === 0) {
                                $this.addClass('bg-green');
                            } else {
                                $this.addClass('bg-green-lighter');
                            }
                        });
                    });

                    var grandTotal = 0;
                    var tickets = $('[data-price]').not('.d-none').map(function () {
                        return parseInt((parseFloat($(this).data('price')) * 100), 10);
                    });


                    for (var i = 0; i < tickets.length; i++) {
                        grandTotal += tickets[i] << 0;
                    }

                    $('[data-bind="grand_total"]').text(RISSB.fn.numberFormat(grandTotal / 100, 2));
                });

                grecaptcha.ready(function() {
                    grecaptcha.execute(rissb_var.recaptcha_site_key, {action: 'user_form'}).then(function(token) {
                        $('[name="recaptcha_token"]').val(token);
                    });
                });

                var $createBookingForm = RISSB.fn.ajaxForm({
                    form: '#form-create-booking',
                    clearForm: false,
                    beforeSubmitCb: function () {
                        if ($('[name="mode"]').val() === 'group' && !$('.js-accordion-attendee').not('.d-none').length && !$('[name="enroller_is_attendee"]').is(':checked')) {
                            alert('Please add at least one attendee before submitting');

                            return false;
                        }

                        if ($('[name="is_validated"]').val() == 1 && $('[name="is_reviewed"]').val() == 0) {
                            $('#modal-booking-confirmation').modal('show');

                            return false;
                        }

                        $('.js-accordion-attendee').each(function () {
                            var $accordion = $(this);
                            var fullname   = $.trim($accordion.find('.js-form-group-first-name input').val()) + ' ' + $.trim($accordion.find('.js-form-group-last-name input').val());

                            $accordion.find('[data-bind="fullname"]').text(fullname + ' - ');
                        });

                        return true;
                    },
                    successCb: function (res) {
                        if ($('[name="is_validated"]').val() == 0 && res.data.validated) {
                            bookingValidatedData = res.data;
                            $('[name="is_validated"]').val(1);
                            $('#form-create-booking').trigger('submit');
                        }
                    },
                    completeCb: function (xhr) {
                        var res = JSON.parse(xhr.responseText);

                        if (!res.data.hasOwnProperty('validated')) {
                            $('[name="is_validated"]').val(0);
                            $('[name="is_reviewed"]').val(0);
                        }
                    },
                });

                $(document).on('click', '#modal-booking-confirmation .js-btn-submit', function (e) {
                    e.preventDefault();

                    $('[name="is_reviewed"]').val(1);
                    $('#form-create-booking').trigger('submit');
                    $('#modal-booking-confirmation').modal('hide');
                });
            }
        }
    });
})(jQuery);

